// Check if a click event included a modifier key or a click with a secondary mouse button.
export default (e) => {
  const modifierKey = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
  const secondaryButton = e.button && e.button !== 0;

  return modifierKey || secondaryButton || false;
};
